<mat-card style="box-shadow:none;    padding: 0px !important;" [class.mat-elevation-z1]="'true'">
    <mat-card-header>
      <span mat-card-avatar>
        <mat-icon>question_answer</mat-icon>
      </span>
      <mat-card-title>{{ modalTitle }}</mat-card-title>
    </mat-card-header>
    <mat-dialog-content style="padding-top: 20px !important;">
        <mat-form-field style="width: 100%;">
            <mat-label style="padding:10px;">Rejection reason:</mat-label>
            <textarea class="textinputupdate" matInput [(ngModel)]="reason"></textarea>
        </mat-form-field>
    </mat-dialog-content>
    <mat-divider></mat-divider>
    <div class="mat-card-actions-container">
      <mat-card-actions>
        <div fxLayout="row">
          <span fxFlex></span>
          <button type="button" mat-raised-button (click)="back()" class="text-upper">Cancel</button>
          <button mat-raised-button (click)="save()"
             color="accent"
            class="text-upper">{{submitTitle}}</button>
        </div>
      </mat-card-actions>
    </div>
</mat-card>
